import { render } from "./TableUserRoles.vue?vue&type=template&id=a0a84c9a"
import script from "./TableUserRoles.vue?vue&type=script&lang=js"
export * from "./TableUserRoles.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__